import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const PERIODS = [["week", "This week"], ["lweek", "Last week"], ["month", "This month"], ["lmonth", "Last month"], ["quarter", "This quarter"], ["lquarter", "Last quarter"], ["custom", "Custom"]];
export const fmtV = (v, unit) => (v == null ? "N/A" : unit === "pct" ? `${v}%` : unit === "tzs" ? `TZS ${Number(v).toLocaleString()}` : v);
export const rate = (s) => (s == null ? ["Not scored", "var(--ng)"] : s >= 85 ? ["Excellent", "var(--ok)"] : s >= 70 ? ["Good", "var(--ac)"] : s >= 50 ? ["Needs attention", "var(--wa)"] : ["Below target", "var(--er)"]);
export const qp = (P) => ({ p: P.p, start: P.start || undefined, end: P.end || undefined });

export function PeriodBar({ P, setP }) {
  return (<>
    <div className="seg2 ptabs" data-testid="perf-period">{PERIODS.map(([k, l]) => <span key={k} className={P.p === k ? "on" : ""} onClick={() => setP({ ...P, p: k })} data-testid={`perf-p-${k}`}>{l}</span>)}</div>
    {P.p === "custom" && <div className="fbar"><div><small>From</small><input className="sel" type="date" value={P.start} onChange={(e) => setP({ ...P, start: e.target.value })} data-testid="perf-from" /></div><div><small>To</small><input className="sel" type="date" value={P.end} onChange={(e) => setP({ ...P, end: e.target.value })} data-testid="perf-to" /></div></div>}
  </>);
}

export const ready = (P) => P.p !== "custom" || (P.start && P.end);

export function useCard(path, P, userId) {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!ready(P)) return undefined;
    let live = true;
    setD(null);
    api.get(path, { params: { ...qp(P), user_id: userId || undefined } }).then((r) => { if (live) setD(r.data); }).catch((e) => { if (live) { toast.error(errMsg(e)); setD({ error: true }); } });
    return () => { live = false; };
  }, [path, P, userId]);
  return d;
}

export function download(params, name) {
  return api.get("/perf/export", { params, responseType: "blob" }).then((r) => {
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url);
  }).catch((e) => toast.error(errMsg(e)));
}
